import createHttpAuthLib from '../../../commons/src/libs/http-json-auth'

import authService from './auth'

export default createHttpAuthLib(authService, false)
